import { TAB_KEY, TIME_TRACKING_EMITTER_CONSTANTS } from '@/shared/config';

const TIME_TRACKING_DURATION = 60;

const TIMEOUT_DURATION = TIME_TRACKING_DURATION * 1000;

const NO_API_CALLING_INTERVAL_DURATION = 15 * 60 * 1000;

const BYPASS_APIS = [
  'checkExpiredToken',
  'pingAiApi',
  'callCenterActiveTimeTracking',
  'monitoringFrontendError',
  'cloudFrontQuerySignature',
];

const CHECK_OVERFLOW_INTERVAL_DURATION = 3 * 60 * 1000;

const LIST_TRAKING_SPACE_ID = [
  '#left-column',
  '#right-column',
  '#date-thumbnail',
  '#button-types',
  '#stripArtifactsBeatHr',
  '#stripAfibsBeatHr',
  '#stripBeatsBeatHr',
  '#stripEventsRhythmEvents',
  '#div-device-strip-management',
  '#div-strip-management',
  '#ecg-viewer',
  '#heat-map',
  '#event-info',
  '#hrs-info',
  '#hr-chart',
  '#hr-chart-options',
  '#strip-info',
  '#ecg-disclosure-info',
  '#report-options',
  '#report-actions',
  '#report-header',
  '#edit-strip',
  '#capture-strip',
  '#add-event',
  '#rr-heatmap-button-types',
  '#template-right-column',
  '#template-overview-item',
];

const TRIGGERED_BY = {
  MOUSE_AND_KEY_TIMEOUT: 'MOUSE_AND_KEY_TIMEOUT',
  VISIBILITY_CHANGE: 'VISIBILITY_CHANGE',
  ACTIVE_TAB_CHANGED: 'ACTIVE_TAB_CHANGED',
  ACTIVE_BUTTON_CHANGED: 'ACTIVE_BUTTON_CHANGED',
  STOP_AI_PROCESSING_EMITTER: 'STOP_AI_PROCESSING_EMITTER',
};

const NEED_AI_STARTED_PROCESSING_TABS: string[] = [
  TAB_KEY.BEATS,
  TAB_KEY.ECG_EVENTS,
  TAB_KEY.HR_SUMMARY,
];

const NEED_BEAT_DOWNLOADED_TABS: string[] = [
  TAB_KEY.BEATS,
  TAB_KEY.ECG_EVENTS,
  TAB_KEY.STRIPS_MANAGEMENT,
  TAB_KEY.HR_SUMMARY,
];

export {
  BYPASS_APIS,
  CHECK_OVERFLOW_INTERVAL_DURATION,
  LIST_TRAKING_SPACE_ID,
  NEED_AI_STARTED_PROCESSING_TABS,
  NEED_BEAT_DOWNLOADED_TABS,
  NO_API_CALLING_INTERVAL_DURATION,
  TIME_TRACKING_DURATION,
  TIME_TRACKING_EMITTER_CONSTANTS,
  TIMEOUT_DURATION,
  TRIGGERED_BY,
};
